import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

export interface SummaryPanelRow {
  label: string;
  value: string | number;
  layout?: "inline" | "stacked";
}

@Component({
  selector: "app-summary-panel",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./SummaryPanelComponent.html",
  styleUrl: "./SummaryPanelComponent.scss",
})
export class AppSummaryPanelComponent {
  @Input({ required: true }) title = "";
  @Input() subtitle?: string;
  @Input() rows: SummaryPanelRow[] = [];
}
